import { useTranslation } from 'react-i18next';

import { Layout, Patients } from '../../../components/app';
import { Button } from '../../../components/common';
import { EnvVariable, ModalName } from '../../../enums';
import { useOpenModal } from '../../../features/modals';
import { useFetchPatients } from '../../../features/patients';
import { getBooleanEnvVariable } from '../../../utils';

export const PatientsPage = () => {
  const { t } = useTranslation();
  const openInvitePatientModal = useOpenModal(ModalName.INVITE_PATIENT);
  const canInvitePatient = getBooleanEnvVariable(EnvVariable.USE_INVITE_PATIENT);

  useFetchPatients();

  return (
    <Layout
      rightButtons={
        canInvitePatient && [
          <Button key="invite" text={t('patients.button.invite')} size="sm" onClick={() => openInvitePatientModal()} />,
        ]
      }
    >
      <Patients />
    </Layout>
  );
};
